// import axiosClient from './axios-client';
// import APAC_countries from '../util/apac_countries';
// import EMEA_countries from '../util/emea_countries';
// import LATAM_countries from '../util/latam_countries'
// import NA_countries from '../util/na_countries';

export async function getCountry(ip?: string) {
  return await fetch(`https://extreme-ip-lookup.com/json/${ip || ''}`)
    .then(res => {
      return res.json();
    })
    .then(json => {
      return json.countryCode;
    })
    .catch(() => {
      return null;
    });
}

// function getRegion(countryCode) {
//   if (APAC_countries.includes(countryCode?.toUpperCase())) {
//     return 'APAC';
//   }
//   if (EMEA_countries.includes(countryCode?.toUpperCase())) {
//     return 'EMEA';
//   }
//   if (LATAM_countries.includes(countryCode?.toUpperCase())) {
//     return 'LATAM';
//   }
//   return null;
// }

// export function getTargetRegion(country) {
//   return getRegion(country);
// }

export async function getTargetRegionAuto(ip?: string) {
  return await fetch(`https://extreme-ip-lookup.com/json/${ip || ''}`)
    .then(res => res.json())
    .then(json => ({
      // region: getRegion(json.countryCode),
      country: json.countryCode,
    }))
    .catch(() => {
      return {
        country: null,
        region: null,
      };
    });
}
